module.exports = __webpack_public_path__ + "static/media/football-helmet.bc3a1dd5.svg";